
import apiClient from './APIClient';
// import { addError } from './errorSlice';
// import { setSuccessMessage } from './successSlice';
// import { startLoading, stopLoading } from './loaderSlice';

export const setupApiClient = (store) => {
  // const dispatch =useDispatch()
  // Inject token from sessionStorage on each request
apiClient.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const userData = state.user.userData; 
    //  const userData = sessionStorage.getItem('userData');
     const jwtToken = userData.JwtToken;
     console.log("jwtToken :", userData);
    // const parsedUserData = userData ? JSON.parse(userData) : null;


    if (jwtToken) {
      config.headers['wg_token'] = jwtToken;
    }
    // Custom loading key OR fallback to URL
    // const loadingKey = config.loadingKey || config.url;
    // store.dispatch(startLoading());

    return config;
  },
  (error) => {
    // const config = error.config || {};
    //   const loadingKey = config.loadingKey || config.url;
    //   store.dispatch(stopLoading());
    Promise.reject(error)
  }
);

  apiClient.interceptors.response.use(
    (response) => {
      const {config }= response;
      // const loadingKey = config.loadingKey || config.url;
    // store.dispatch(stopLoading());
      const { status = 200, message = '', data = null } = response ?? {};
      const method = response?.config?.method?.toUpperCase();

      if (status >= 200 && status < 300) {        
        // if (message && (method === 'POST' || method === 'PUT'|| method === 'DELETE')) {
        //   store.dispatch(setSuccessMessage(message));
        // }
        // console.log("data :", response, data);
        
        return data;
       }

      // store.dispatch(addError(message || 'Something went wrong.'));
    //   return Promise.reject(new Error(message));
    },
    (error) => {
      const config = error.config || {};
      // const loadingKey = config.loadingKey || config.url;
    //   store.dispatch(stopLoading());

      const message =
        error?.response?.data?.errorMessage ||
        // error?.message ||
        'Unexpected error occurred.';

    //   store.dispatch(addError(message));
      return Promise.reject(error);
    }
  );
};
